import React, { PropsWithChildren } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { WrappedCardListItemSubComponent } from '../CardListItem/cardListItemSubComponent';
import {
  CardListItemTitleWithSubtitle,
  CardListItemTitleWithSubtitleProps
} from '../CardListItemTitleWithSubtitle/CardListItemTitleWithSubtitle';

export type CardListItemTitleProps = PropsWithChildren<
  Omit<CardListItemTitleWithSubtitleProps, 'children'>
>;

export const CardListItemTitle: WrappedCardListItemSubComponent<
  CardListItemTitleProps
> = (props) => {
  const { children, ...remainingProps } = prepareProps({ props });

  return (
    <CardListItemTitleWithSubtitle {...remainingProps}>
      {() => ({
        title: children,
        subtitle: null
      })}
    </CardListItemTitleWithSubtitle>
  );
};
